// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-group-list {
  background: #fff;
  height: 100vh;
}
.conversation-group-list .searchBox-pad {
  width: 90%;
  margin-left: 10px;
}
.conversation-group-list .input {
  height: 2rem;
}
.conversation-group-list .input-search-box {
  width: 100%;
}
.conversation-group-list .input-search-box .icon.is-left {
  height: 2rem;
}
.conversation-group-list .level-left {
  width: 100%;
}

.second-level-menu {
  max-width: 280px;
  min-width: 280px;
}

.list-wrapper ul li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul li .group-identify {
  top: 10px !important;
}
.list-wrapper ul li .group-identify .pi {
  font-size: 1.3rem !important;
  color: #959595 !important;
}
.list-wrapper ul li .badge-count {
  bottom: 0px !important;
}
.list-wrapper ul li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-top: 1px solid #4bf768;
  border-bottom: 1px solid #4bf768;
}
.list-wrapper ul li.active .list-active, .list-wrapper ul li.active .chat-msg-text {
  color: var(--listcolor) !important;
}
.list-wrapper ul li.active ::ng-deep .empty-img {
  background: #9affc6 !important;
}
.list-wrapper ul li:hover {
  background: var(--listbackgoundhover) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat-list/chat-list.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EAEC,aAAA;AAAL;AAEI;EACI,UAAA;EACA,iBAAA;AAAR;AAEI;EACI,YAAA;AAAR;AAEI;EACI,WAAA;AAAR;AACQ;EACI,YAAA;AACZ;AAEI;EACI,WAAA;AAAR;;AAIA;EACI,gBAAA;EACA,gBAAA;AADJ;;AAMQ;EAEI,2CAAA;AAJZ;AAKW;EACC,oBAAA;AAHZ;AAIY;EACI,4BAAA;EACA,yBAAA;AAFhB;AAKW;EACC,sBAAA;AAHZ;AAOO;EACE,gDAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;AALT;AAOS;EACG,kCAAA;AALZ;AAOQ;EACI,8BAAA;AALZ;AAUO;EACI,gDAAA;AARX","sourcesContent":[".conversation-group-list{\n    background: #fff;\n   \n     height:100vh;\n     \n    .searchBox-pad{\n        width:90%;\n        margin-left:10px;\n    }\n    .input{\n        height:2rem;\n    }\n    .input-search-box{\n        width:100%;\n        .icon.is-left{\n            height:2rem;\n        }\n    }\n    .level-left{\n        width:100%;\n    }\n}\n\n.second-level-menu  {\n    max-width: 280px;\n    min-width: 280px;\n}\n\n.list-wrapper{\n    ul {\n        li{\n           \n            color: var(--textsecondarycolor) !important;\n           .group-identify{\n            top:10px !important;\n            .pi{\n                font-size:1.3rem !important;\n                color: #959595 !important;\n            }\n           }\n           .badge-count{\n            bottom:0px !important;\n           }\n        }\n       \n       li.active{\n         background:var(--listbackgoundhover) !important;\n         color:var(--listcolor) !important;\n         border-top:1px solid #4bf768;\n         border-bottom: 1px solid #4bf768;\n        \n         .list-active,.chat-msg-text{\n            color:var(--listcolor) !important;\n         }\n        ::ng-deep .empty-img{\n            background: #9affc6 !important;\n         }\n\n       }\n\n       li:hover{\n           background:var(--listbackgoundhover) !important;\n       }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
